<template lang="pug">
.pulldown-search
  .pulldown-search__label.text-small
    slot
  .pulldown-search__input
    select-base.pulldown-search__input__select(@input='updateValue')
      option-base.pulldown-search__input__select__option(
        v-for='(option, index) in selectOptions',
        :value='option.value',
        :key='index',
        :selected='option.value === value'
      ) {{ option.label }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import SelectBase from '@/components/atoms/SelectBase.vue'
import OptionBase from '@/components/atoms/OptionBase.vue'
import { InputItem } from '@/models/inputItem'

/**
 * 検索プルダウン
 */
@Component({
  components: {
    SelectBase,
    OptionBase,
  },
})
export default class PulldownSearch extends Vue {
  // セレクトオプション
  @Prop()
  selectOptions!: InputItem[]

  // 選択値
  @Prop({ default: '' })
  value!: string

  private updateValue(value: string): void {
    this.$emit('input', value)
  }
}
</script>

<style lang="stylus" scoped>
.pulldown-search
  width 160px
  &__label
    padding 5px
  &__input
    position relative
    &__select
      width 100%
      height var(--input-height-default)
      appearance none
      outline none
      padding 0 15px
      border 1px solid var(--color-default__input-border)
      border-radius 20px

    &::before
      position absolute
      top 50%
      right 10px
      width 0
      height 0
      padding 0
      content ''
      border-left 6px solid transparent
      border-right 6px solid transparent
      border-top 6px solid var(--color-default__input-border)
      pointer-events none
</style>
